<div class="row justify-content-center">
  <div class="col-auto">
    <div class="section-header mb-4 d-flex text-center justify-content-center gap-2" style="max-width: 520px;">
      <span class="material-symbols-outlined">groups</span>
      <h1 class="h4">Listado de <strong class="fw-semibold text-colonial">usuarios</strong></h1>
    </div>
    <p class="text-muted mx-auto text-center" style="max-width: 520px;">Visualiza y filtra los usuarios y gestiona
      solicitudes de registro.</p>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-12 col-xl-10">

    <shared-tabs [tabs]="['Usuarios', 'Solicitudes de registro']">
      <!-- TAB 1: USERS -->
      <ng-template appTabContent>
        <!-- Supervisor filters: bank -> branch, and role/status -->
        <div *ngIf="isSupervisor" class="card shadow-sm mb-3 rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">filter_list</span>
              <span>Filtros</span>
            </h3>
          </div>
          <div class="card-body">
            <form [formGroup]="filtersForm" class="row g-3 align-items-end">
              <div class="col-12 col-md-4">
                <label class="form-label">Banco</label>
                <select class="form-select" formControlName="bankId">
                  <option value="">Todos</option>
                  <option *ngFor="let b of banks" [value]="b.id">{{ b.name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label">Sucursal</label>
                <select class="form-select" formControlName="branchId">
                  <option value="">Todas</option>
                  <option *ngFor="let br of filteredBranches" [value]="br.branchId">{{ br.name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-2">
                <label class="form-label">Rol</label>
                <select class="form-select" formControlName="role">
                  <option *ngFor="let r of userRoleOptions" [value]="r.value">{{ r.label }}</option>
                </select>
              </div>
              <div class="col-12 col-md-2">
                <label class="form-label">Estado</label>
                <select class="form-select" formControlName="status">
                  <option value="">Todos</option>
                  <option value="Active">Activo</option>
                  <option value="Inactive">Inactivo</option>
                  <option value="Pending">Pendiente</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <!-- Director filters (global/regional): branch within their scope, role, status -->
        <div *ngIf="isDirector" class="card shadow-sm mb-3 rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">filter_list</span>
              <span>Filtros</span>
            </h3>
          </div>
          <div class="card-body">
            <form [formGroup]="filtersForm" class="row g-3 align-items-end">
              <div class="col-12 col-md-4">
                <label class="form-label">Sucursal</label>
                <select class="form-select" formControlName="branchId">
                  <option value="">Todas</option>
                  <option *ngFor="let br of directorBranches" [value]="br.id">{{ br.name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label">Rol</label>
                <select class="form-select" formControlName="role">
                  <option *ngFor="let r of userRoleOptions" [value]="r.value">{{ r.label }}</option>
                </select>
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label">Estado</label>
                <select class="form-select" formControlName="status">
                  <option value="">Todos</option>
                  <option value="Active">Activo</option>
                  <option value="Inactive">Inactivo</option>
                  <option value="Pending">Pendiente</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <!-- Manager filters: role/status only -->
        <div *ngIf="isManager" class="card shadow-sm mb-3 rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">filter_list</span>
              <span>Filtros</span>
            </h3>
          </div>
          <div class="card-body">
            <form [formGroup]="filtersForm" class="row g-3 align-items-end">
              <div class="col-12 col-md-6">
                <label class="form-label">Rol</label>
                <select class="form-select" formControlName="role">
                  <option *ngFor="let r of userRoleOptions" [value]="r.value">{{ r.label }}</option>
                </select>
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label">Estado</label>
                <select class="form-select" formControlName="status">
                  <option value="">Todos</option>
                  <option value="Active">Activo</option>
                  <option value="Inactive">Inactivo</option>
                  <option value="Pending">Pendiente</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <!-- SuperUser filters: every user of the platform -->
        <div *ngIf="isSuperUser" class="card shadow-sm mb-3 rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3">
            <h3 class="h5 d-flex gap-2 mb-0 align-items-center">
              <span class="material-symbols-outlined text-colonial">filter_list</span>
              <span>Filtros</span>
            </h3>
          </div>
          <div class="card-body">
            <form [formGroup]="filtersForm" class="row g-3 align-items-end">
              <div class="col-12 col-md-4">
                <label class="form-label">Banco</label>
                <select class="form-select" formControlName="bankId">
                  <option value="">Todos</option>
                  <option *ngFor="let b of banks" [value]="b.id">{{ b.name }}</option>
                </select>
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label">Rol</label>
                <select class="form-select" formControlName="role">
                  <option *ngFor="let r of platformRoleOptions" [value]="r.value">{{ r.label }}</option>
                </select>
              </div>
              <div class="col-12 col-md-4">
                <label class="form-label">Estado</label>
                <select class="form-select" formControlName="status">
                  <option value="">Todos</option>
                  <option value="Active">Activo</option>
                  <option value="Inactive">Inactivo</option>
                  <option value="Pending">Pendiente</option>
                </select>
              </div>
            </form>
          </div>
        </div>

        <div class="card shadow-sm border-0 overflow-hidden rounded-4">
          <shared-table-container>
            <shared-table [headers]="tableHeaders" [items]="employees" searchPlaceholder="Buscar usuarios"
              [(searchValue)]="searchValue" (endSearching)="onSearch($event)">
              <ng-template let-role="role" sharedTableColumn="role">
                <span>{{ displayPlatformRole(role) }}</span>
              </ng-template>
              <ng-template let-bankName="bankName" sharedTableColumn="bankName">
                <span>{{ bankName || '-' }}</span>
              </ng-template>
              <ng-template let-id="id" let-status="status" let-kind="kind" sharedTableColumn="status">
                <button *ngIf="canToggleStatus(kind, status); else statusText"
                  (click)="$event.stopPropagation(); openStatusModalFor(id)"
                  class="btn btn-sm btn-outline-secondary" type="button">
                  {{ displayStatus(status) }}
                </button>
                <ng-template #statusText><span>{{ displayStatus(status) }}</span></ng-template>
              </ng-template>
              <ng-template let-branchId="branchId" let-branchName="branchName" sharedTableColumn="branchId">
                <span>{{ getBranchDisplay(branchName, branchId) }}</span>
              </ng-template>
              <ng-template let-id="id" let-kind="kind" sharedTableColumn="actions">
                <div class="d-flex gap-2" *ngIf="!isSuperUser || kind === 'employee'">
                  <button (click)="$event.stopPropagation(); openStatsModal(id)"
                    class="btn btn-sm btn-outline-secondary" type="button" title="Ver producción">
                    <span class="material-symbols-outlined" style="font-size: 18px;">query_stats</span>
                  </button>
                  <ng-container *ngIf="canManageEmployees && !isSuperUser">
                  <button (click)="$event.stopPropagation(); openEmployeeModal(id)"
                    class="btn btn-sm btn-outline-secondary" type="button" title="Editar y reasignar">
                    <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                  </button>
                  <button (click)="$event.stopPropagation(); removeEmployee(id)"
                    class="btn btn-sm btn-outline-danger" type="button" title="Eliminar">
                    <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                  </button>
                  </ng-container>
                </div>
              </ng-template>
            </shared-table>
          </shared-table-container>
        </div>
      </ng-template>

      <!-- TAB 2: PENDING REGISTRATIONS -->
      <ng-template appTabContent>
        <div class="card shadow-sm mb-3 rounded-4 overflow-hidden">
          <div class="card-header bg-white py-3 d-flex align-items-center justify-content-between">
            <h3 class="h6 mb-0 d-flex gap-2 align-items-center">
              <span class="material-symbols-outlined text-colonial">person_add</span>
              <span>Solicitudes de registro pendientes</span>
            </h3>
            <div class="d-flex align-items-center gap-2">
              <label class="form-label m-0 small">Rol</label>
              <select (change)="loadPendingRegistrations()" [(ngModel)]="pendingRoleFilter"
                class="form-select form-select-sm">
                <option *ngFor="let r of registrationRoleOptions" [ngValue]="r.value">{{ r.label }}</option>
              </select>
            </div>
          </div>
          <div class="card-body p-0">
            <shared-table-container>
              <shared-table [headers]="[
                  { attribute: 'firstName', label: 'Nombre' },
                  { attribute: 'lastName', label: 'Apellido' },
                  { attribute: 'email', label: 'Correo' },
                  { attribute: 'documentNumber', label: 'Documento' },
                  { attribute: 'requestedRole', label: 'Rol solicitado' },
                  { attribute: 'bankName', label: 'Banco' },
                  { attribute: 'branchName', label: 'Sucursal' },
                  { attribute: 'createdAt', label: 'Creado', type: 'datetime' },
                  { attribute: 'actions', label: 'Acciones' }
                ]" [items]="pendingRegistrations" noItemsTitle="Sin solicitudes pendientes">
                <ng-template let-requestedRole="requestedRole" sharedTableColumn="requestedRole">
                  <span>{{ displayRequestedRole(requestedRole) }}</span>
                </ng-template>
                <ng-template let-branchName="branchName" let-assignments="assignments"
                  sharedTableColumn="branchName">
                  <span>{{ displayBranches(branchName, assignments) }}</span>
                </ng-template>
                <ng-template let-id="id" sharedTableColumn="actions">
                  <button *ngIf="canApproveRegistration(id)"
                    (click)="$event.stopPropagation(); openRegistrationModal(id)"
                    class="btn btn-sm btn-outline-secondary" type="button" title="Revisar solicitud">
                    <span class="material-symbols-outlined" style="font-size: 18px;">rate_review</span>
                  </button>
                </ng-template>
              </shared-table>
            </shared-table-container>
          </div>
        </div>
      </ng-template>
    </shared-tabs>

  </div>
</div>

<app-employee-modal *ngIf="showEmployeeModal" [employee]="editingEmployee!" [branches]="modalBranches"
  [isVisible]="showEmployeeModal" (closed)="onEmployeeModalClosed($event)"></app-employee-modal>

<app-registration-approval-modal *ngIf="showRegistrationModal" [registration]="reviewingRegistration!"
  [isVisible]="showRegistrationModal"
  (closed)="onRegistrationModalClosed($event)"></app-registration-approval-modal>

<app-status-change-modal *ngIf="statusChange" [options]="statusOptions" [currentStatus]="statusChange.current"
  (closed)="onStatusModalClosed($event)"></app-status-change-modal>

<app-employee-stats-modal *ngIf="statsEmployee" [employee]="statsEmployee"
  (closed)="onStatsModalClosed()"></app-employee-stats-modal>